"use client";

import { SectionPillTabs } from "@/components/peeqd/PeeqdPreview";
import type { PeeqdReportTabId } from "@/config/peeqdContent";

interface DashboardDetailLoadingShellProps {
  section: PeeqdReportTabId;
  variant?: "full" | "summary" | "lists";
}

function SummarySkeleton() {
  return (
    <div className="mt-3 rounded-2xl border border-line bg-surface px-4 py-4 shadow-soft sm:px-5">
      <div className="sk h-3 w-32" />
      <div className="mt-4 space-y-3">
        <div className="sk h-14 w-full rounded-xl" />
        <div className="sk h-14 w-[92%] rounded-xl" />
        <div className="sk h-14 w-[85%] rounded-xl" />
      </div>
    </div>
  );
}

function ListsSkeleton() {
  return (
    <div className="w-full space-y-3">
      <div className="grid grid-cols-2 gap-1 rounded-xl bg-[#F6E9E7] p-1">
        <div className="sk h-28 rounded-lg" />
        <div className="sk h-28 rounded-lg" />
      </div>
      <div className="flex gap-2">
        <div className="sk h-9 w-20 rounded-full" />
        <div className="sk h-9 w-20 rounded-full" />
        <div className="sk h-9 w-24 rounded-full" />
      </div>
      <div className="overflow-hidden rounded-2xl border border-line bg-surface shadow-card">
        <div className="space-y-2 p-4">
          <div className="sk h-16 rounded-xl" />
          <div className="sk h-16 rounded-xl" />
          <div className="sk h-16 rounded-xl" />
        </div>
      </div>
    </div>
  );
}

/** Right-pane placeholders while scrape jobs or detail data load. */
export default function DashboardDetailLoadingShell({
  section,
  variant = "full",
}: DashboardDetailLoadingShellProps) {
  if (variant === "summary") return <SummarySkeleton />;
  if (variant === "lists") return <ListsSkeleton />;

  return (
    <>
      <div className="no-bar flex gap-2 overflow-x-auto">
        <div className="sk h-10 w-24 shrink-0 rounded-full" />
        <div className="sk h-10 w-28 shrink-0 rounded-full" />
        <div className="sk h-10 w-32 shrink-0 rounded-full" />
      </div>

      <SummarySkeleton />

      <div className="mt-4 w-full opacity-60 pointer-events-none">
        <SectionPillTabs active={section} onChange={() => {}} align="center" />
      </div>

      <div className="mt-4 w-full">
        <ListsSkeleton />
      </div>
    </>
  );
}
